export const VIEW_DETAILS_PAGE = "VIEW_DETAILS_PAGE";
export const HIDE_DETAILS_PAGE = "HIDE_DETAILS_PAGE";

export const DIAMOND_DETAILS = "DIAMOND_DETAILS";
export const SETTING_DETAILS = "SETTING_DETAILS";
